var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Config } from "../Config";
import { FaceTecSDK } from "../../core-sdk/FaceTecSDK.js/FaceTecSDK";
import { SessionRequestProcessor } from "./processors/SessionRequestProcessor";
import { MigrationProcessor } from "./processors/MigrationProcessor";
import { SampleAppUtilities } from "./utilities/SampleAppUtilities";
import { DeveloperStatusMessages } from "./utilities/DeveloperStatusMessages";
import { UserFriendlyMessages } from "./utilities/UserFriendlyMessages";
import { FACETEC_SPANISH_STRINGS, FACETEC_OCR_SPANISH } from "./utilities/SpanishLocalization";
export var FacetecApp = (function () {
    var latestExternalDatabaseRefID = "";
    var faceTecSDKInstance;
    var isInitialized = false;
    var pendingInitializationActions = [];
    // Wait for onload to be complete before attempting to access the Browser SDK.
    window.onload = function () {
        // Set a the directory path for other FaceTec Browser SDK Resources.
        FaceTecSDK.setResourceDirectory("../../core-sdk/FaceTecSDK.js/resources");
        // Set the directory path for required FaceTec Browser SDK images.
        FaceTecSDK.setImagesDirectory("../../core-sdk/FaceTec_images");
        // Initialize FaceTec Browser SDK and configure the UI features.
        FaceTecSDK.initializeWithSessionRequest(Config.DeviceKeyIdentifier, new SessionRequestProcessor(generateExternalDatabaseRefID(), onComplete), {
            onSuccess: function (newFaceTecSdkInstance) {
                faceTecSDKInstance = newFaceTecSdkInstance;
                SampleAppUtilities.enableAllButtons();
                onFaceTecSDKInitializationSuccess();
                isInitialized = true;
                flushPendingInitializationActions();
            },
            onError: onFaceTecSDKInitializationFailure
        });
        SampleAppUtilities.formatUIForDevice();
    };
    // Finish setup after initialization success
    function onFaceTecSDKInitializationSuccess() {
        console.log("FaceTec SDK was initialized successfully.");
        // Aplicar localización en español
        try {
            FaceTecSDK.configureLocalization(FACETEC_SPANISH_STRINGS);
            FaceTecSDK.configureOCRLocalization(FACETEC_OCR_SPANISH);
            console.log("✅ Localización en español aplicada exitosamente");
        }
        catch (error) {
            console.error("❌ Error aplicando localización:", error);
        }
        // Aplicar customización personalizada
        try {
            var customization = Config.retrieveConfigurationWizardCustomization(FaceTecSDK);
            var lowLightCustomization = Config.retrieveLowLightConfigurationWizardCustomization(FaceTecSDK);
            var dynamicDimmingCustomization = Config.retrieveDynamicDimmingConfigurationWizardCustomization(FaceTecSDK);
            FaceTecSDK.setCustomization(customization);
            FaceTecSDK.setLowLightCustomization(lowLightCustomization);
            FaceTecSDK.setDynamicDimmingCustomization(dynamicDimmingCustomization);
            console.log("✅ Customización aplicada exitosamente (normal, low-light, dynamic-dimming)");
        }
        catch (error) {
            console.error("❌ Error aplicando customización:", error);
        }
        SampleAppUtilities.displayStatus("Inicializado Exitosamente.");
    }
    ;
    function flushPendingInitializationActions() {
        if (pendingInitializationActions.length === 0) {
            return;
        }
        var actionsToRun = pendingInitializationActions.slice();
        pendingInitializationActions = [];
        actionsToRun.forEach(function (action) {
            try {
                action();
            }
            catch (error) {
                console.error("Error al ejecutar una acción pendiente después de la inicialización de FaceTec.", error);
            }
        });
    }
    function runAfterInitialization(callback) {
        if (isInitialized) {
            callback();
            return;
        }
        pendingInitializationActions.push(callback);
    }
    // Handle initialization unsuccess
    function onFaceTecSDKInitializationFailure(initializationError) {
        SampleAppUtilities.displayStatus("Initialization Failure.");
        // SampleAppUtilities.fadeInMainUIContainer();
        // DeveloperStatusMessages.logInitializationErrorResult(initializationError);
    }
    ;
    // Initiate a 3D Liveness Check.
    function onLivenessCheckPressed() {
        window.showStepper('verification');
        window.updateStepperProgress(1);
        SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
        // Get the last enrolled user's ID from localStorage
        var enrolledUserID = localStorage.getItem('lastEnrolledUserID');
        if (!enrolledUserID) {
            alert("No hay usuarios enrollados. Por favor, primero regístrate en /enroll");
            SampleAppUtilities.showMainUI();
            SampleAppUtilities.enableAllButtons();
            window.hideStepper();
            return;
        }
        console.log("🔍 Verificando contra usuario enrollado:", enrolledUserID);
        var sessionRequestProcessor = new SessionRequestProcessor(enrolledUserID, onComplete);
        faceTecSDKInstance.start3DLivenessThen3DFaceMatch(sessionRequestProcessor);
        console.log("sessionRequestProcessor", sessionRequestProcessor);
        console.log("onFaceTecExit", sessionRequestProcessor.onFaceTecExit.toString());
        console.log("faceTecSDKInstance", faceTecSDKInstance);
        console.log("latestExternalDatabaseRefID", latestExternalDatabaseRefID);
    }
    // Initiate a 3D Liveness enrollment with Photo ID Match.
    function onEnrollUserPressed() {
        return __awaiter(this, void 0, void 0, function () {
            var urlParams, enrollmentImageUrl, imageBase64, migrationProcessor, error_1, sessionRequestProcessor;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        window.showStepper('enroll');
                        window.updateStepperProgress(1);
                        SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
                        latestExternalDatabaseRefID = generateExternalDatabaseRefID();
                        urlParams = new URLSearchParams(window.location.search);
                        enrollmentImageUrl = urlParams.get('enrollmentImageUrl');
                        if (!(enrollmentImageUrl && enrollmentImageUrl.trim() !== '')) return [3 /*break*/, 5];
                        console.log('🔄 [Migration] Detectado enrollmentImageUrl, iniciando flujo de migración');
                        console.log('📸 [Migration] URL de imagen:', enrollmentImageUrl.substring(0, 50) + '...');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, downloadAndConvertImageToBase64(enrollmentImageUrl)];
                    case 2:
                        imageBase64 = _a.sent();
                        console.log('✅ [Migration] Imagen descargada y convertida a base64:', imageBase64.substring(0, 50) + '...');
                        migrationProcessor = new MigrationProcessor(latestExternalDatabaseRefID, imageBase64, onComplete);
                        console.log('🚀 [Migration] Iniciando 3D Liveness para migración');
                        faceTecSDKInstance.start3DLiveness(migrationProcessor);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('❌ [Migration] Error en flujo de migración:', error_1);
                        alert('Error al procesar la imagen de migración. Por favor, intenta nuevamente.');
                        SampleAppUtilities.showMainUI();
                        SampleAppUtilities.enableAllButtons();
                        window.hideStepper();
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        // Normal enrollment flow with Photo ID Match
                        console.log('📝 [Enrollment] Flujo normal de enrollment con Photo ID Match');
                        sessionRequestProcessor = new SessionRequestProcessor(latestExternalDatabaseRefID, onComplete);
                        faceTecSDKInstance.start3DLivenessThen3D2DPhotoIDMatch(sessionRequestProcessor);
                        console.log("sessionRequestProcessor", sessionRequestProcessor);
                        console.log("onFaceTecExit", sessionRequestProcessor.onFaceTecExit.toString());
                        console.log("faceTecSDKInstance", faceTecSDKInstance);
                        console.log("latestExternalDatabaseRefID", latestExternalDatabaseRefID);
                        console.log("faceTecSDKInstance", sessionRequestProcessor.demonstrationExternalDatabaseRefID);
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    ;
    // Show the final result and transition back into the main interface.
    function onComplete(sessionStatus) {
        console.log("onComplete", sessionStatus);
        DeveloperStatusMessages.logSessionStatusOnFaceTecExit(sessionStatus);
        window.hideStepper();
        var userMessage = UserFriendlyMessages.getMessageForStatus(sessionStatus);
        var statusElement = document.getElementById("status");
        if (statusElement) {
            statusElement.className = '';
            statusElement.classList.add(userMessage.type);
        }
        if (sessionStatus === FaceTecSDK.FaceTecSessionStatus.SessionCompleted) {
            // Save the enrolled user ID to localStorage if it was an enrollment
            if (latestExternalDatabaseRefID && latestExternalDatabaseRefID !== "") {
                localStorage.setItem('lastEnrolledUserID', latestExternalDatabaseRefID);
                console.log("✅ Usuario enrollado guardado:", latestExternalDatabaseRefID);
            }
            SampleAppUtilities.displayStatus(userMessage.text);
        }
        else {
            latestExternalDatabaseRefID = "";
            SampleAppUtilities.displayStatus(userMessage.text);
        }
        // Llamar al handler de Flutter InAppWebView si está disponible
        try {
            if (window.flutter_inappwebview) {
                // Obtener datos de validación si existen
                var validationData = window.faceTecValidationData || null;
                var completeData = {
                    sessionStatus: sessionStatus,
                    validation: validationData
                };
                console.log("📱 [Flutter Bridge] Llamando a handler onComplete con datos:", completeData);
                window.flutter_inappwebview.callHandler('onComplete', completeData);
                // Limpiar la validación después de enviarla
                window.faceTecValidationData = null;
            }
        }
        catch (e) {
            console.error("❌ [Flutter Bridge] Error llamando handler:", e);
        }
        SampleAppUtilities.showMainUI();
        SampleAppUtilities.enableAllButtons();
    }
    function generateExternalDatabaseRefID() {
        // Try to get RUT from URL parameters first
        var urlParams = new URLSearchParams(window.location.search);
        var rutFromUrl = urlParams.get('rut');
        if (rutFromUrl && rutFromUrl.trim() !== '') {
            console.log("✅ Usando RUT desde URL:", rutFromUrl);
            return rutFromUrl.trim();
        }
        // Fallback: Create a new externalDatabaseRefID
        console.log("⚠️ No se encontró RUT en URL, generando ID aleatorio");
        return "browser_sample_app_" + SampleAppUtilities.generateUUId();
    }
    ;
    function getLatestEnrollmentIdentifier() {
        return latestExternalDatabaseRefID;
    }
    // Helper function to download image from URL and convert to base64
    function downloadAndConvertImageToBase64(imageUrl) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log('📥 [Migration] Descargando imagen desde:', imageUrl.substring(0, 100) + '...');
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var img = new Image();
                        // Enable CORS for S3 images
                        img.crossOrigin = 'anonymous';
                        img.onload = function () {
                            try {
                                console.log('✅ [Migration] Imagen cargada exitosamente');
                                console.log('📐 [Migration] Dimensiones:', img.width, 'x', img.height);
                                // Create canvas to convert image to base64
                                var canvas = document.createElement('canvas');
                                canvas.width = img.width;
                                canvas.height = img.height;
                                var ctx = canvas.getContext('2d');
                                if (!ctx) {
                                    reject(new Error('No se pudo obtener contexto 2D del canvas'));
                                    return;
                                }
                                // Draw image on canvas
                                ctx.drawImage(img, 0, 0);
                                // Convert to base64
                                var base64 = canvas.toDataURL('image/jpeg');
                                console.log('✅ [Migration] Imagen convertida a base64 (length:', base64.length, ')');
                                resolve(base64);
                            }
                            catch (error) {
                                console.error('❌ [Migration] Error al convertir imagen a base64:', error);
                                reject(error);
                            }
                        };
                        img.onerror = function (error) {
                            console.error('❌ [Migration] Error al cargar imagen:', error);
                            reject(new Error('Error al cargar la imagen desde S3'));
                        };
                        // Start loading the image
                        img.src = imageUrl;
                    })];
            });
        });
    }
    return {
        onFaceTecSDKInitializationSuccess: onFaceTecSDKInitializationSuccess,
        onFaceTecSDKInitializationFailure: onFaceTecSDKInitializationFailure,
        onLivenessCheckPressed: onLivenessCheckPressed,
        onComplete: onComplete,
        generateExternalDatabaseRefID: generateExternalDatabaseRefID,
        getLatestEnrollmentIdentifier: getLatestEnrollmentIdentifier,
        onEnrollUserPressed: onEnrollUserPressed,
        runAfterInitialization: runAfterInitialization,
    };
})();
